import API from './api';

export default class AffiliateMarketplaceInviteApi {
  static getList(params) {
    return API.get('/advertisers/affiliate_marketplace_invites', params);
  }

  static create(params) {
    return API.post('/advertisers/affiliate_marketplace_invites', params);
  }

  static preview(params) {
    return API.post('/advertisers/affiliate_marketplace_invites/preview', params);
  }
}
